"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorityNav = void 0;
var react_1 = __importStar(require("react"));
var ToggleButton_1 = require("./ToggleButton");
var lodash_1 = __importDefault(require("lodash"));
var usePrevious_1 = require("../../hooks/usePrevious");
var deviceHelper_1 = require("../../helpers/deviceHelper");
var classnames_1 = __importDefault(require("classnames"));
var reducer_1 = require("./reducer");
var useResizeObserve_1 = require("../../hooks/useResizeObserve");
var DivElement_1 = require("./DivElement");
var PriorityNav = function (props) {
    var outerNav = react_1.useRef(null);
    var nav = react_1.useRef(null);
    var items = react_1.useRef(new Map()).current;
    var _a = ToggleButton_1.useToggleButton(), isOpen = _a.isOpen, buttonProps = __rest(_a, ["isOpen"]);
    var previousVisibleFilters = usePrevious_1.usePrevious(!!props.visibleFilters);
    var _b = react_1.useState(false), isReady = _b[0], setIsReady = _b[1];
    var childrenToName = function () {
        return react_1.default.Children.map(props.children, function (c) { return c.props.filter.name; });
    };
    var namesToChildren = function (names) {
        var children = props.children;
        return names
            .map(function (n) {
            return children.find(function (child) { return child.props.filter.name === n; });
        })
            .filter(function (c) { return !!c; });
    };
    var getInit = function () {
        return {
            children: childrenToName(),
            dropdownItems: [],
            lastItemWidth: [],
        };
    };
    var _c = react_1.useReducer(reducer_1.reducer, getInit()), state = _c[0], dispatch = _c[1];
    var outerNavWidth = useResizeObserve_1.useResizeObserve(outerNav);
    react_1.useLayoutEffect(function () {
        doesItFit();
    }, [state.children, state.dropdownItems, outerNavWidth]);
    // We need to trace visible filter changes and reset everything
    // A trick to track an array
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    react_1.useEffect(function () {
        if (!lodash_1.default.isUndefined(previousVisibleFilters) &&
            previousVisibleFilters !== !!props.visibleFilters) {
            dispatch({
                type: 'reset',
                payload: getInit(),
            });
            doesItFit();
        }
    }, [props.visibleFilters]);
    react_1.useEffect(function () {
        setIsReady(false);
    }, [props.appliedFilters.deal]);
    react_1.useEffect(function () {
        !isReady &&
            dispatch({
                type: 'reset',
                payload: getInit(),
            });
        doesItFit();
    }, [isReady]);
    react_1.useEffect(function () {
        lodash_1.default.debounce(function () {
            setIsReady(true);
        }, 1000)();
    }, [state.children.length, props.appliedFilters.deal]);
    var doesItFit = lodash_1.default.debounce(function () {
        if (nav.current && outerNav.current) {
            var outerWidth_1 = outerNav.current.offsetWidth;
            var totalWidth_1 = props.moreBtn.current
                ? props.moreBtn.current.offsetWidth
                : 0;
            items.forEach(function (item) {
                totalWidth_1 += item.offsetWidth;
            });
            if (state.children.length > 0 && totalWidth_1 > outerWidth_1) {
                moveItemToList();
            }
            else if (outerWidth_1 >
                totalWidth_1 + props.itemWidth + props.offset) {
                moveItemToNav();
            }
        }
    }, props.debounce);
    var moveItemToList = function () {
        dispatch({
            type: 'move',
            payload: {
                lastItem: items.get(state.children.length - 1),
            },
        });
    };
    var moveItemToNav = function () {
        dispatch({
            type: 'return',
        });
    };
    return (react_1.default.createElement(DivElement_1.Div, { ref: outerNav, className: classnames_1.default('priority-navigation', {
            'priority-nav-root-hidden': (deviceHelper_1.isTabletBreakPoint() && state.children.length) ||
                !isReady,
            'priority-nav-root': !deviceHelper_1.isMobile() && !state.children.length,
        }, props.className) },
        react_1.default.createElement(DivElement_1.Div, { ref: nav, className: "priority-nav-main" },
            react_1.default.Children.map(namesToChildren(state.children), function (child, index) {
                return (react_1.default.createElement(DivElement_1.Div, { ref: function (s) {
                        if (s) {
                            items.set(index, s);
                        }
                    }, style: {
                        padding: props.itemPadding,
                    }, className: 'priority-nav-item', key: index }, nav.current && child));
            }),
            state.dropdownItems.length > 0 &&
                props.dropdown({
                    dropdownItems: namesToChildren(state.dropdownItems),
                    buttonProps: buttonProps,
                    isOpen: isOpen,
                }))));
};
exports.PriorityNav = PriorityNav;
